<template>
  <div>
    <DirectoryTable
      title="Тип события"
      :table-headers="tableHeaders"
      :data-loaded="dataLoaded"
      :table-loading="tableLoading"
      :data="eventTypePartList.list"
      @edit="edit"
      @remove="remove"
      @addBtnClick="dialog = true"
    />

    <EventTypePartDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @save="saveEventTypePart"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeEventTypePart"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import { eventTypePartApi } from '@/api'
import { EventTypePartList } from '@/models'
import EventTypePartDialog from '@/components/Spm/Directories/EventTypePart/dialogs/EventTypePartDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import DirectoryTable from '@/components/Spm/Directories/DirectoryTable'

export default {
  name: 'EventPartTypePage',

  metaInfo: { title: 'Тип события' },

  components: {
    DirectoryTable,
    EventTypePartDialog,
    ConfirmDialog,
  },

  async created() {
    await this.getEventTypePartParent()
    this.dataLoaded = true
  },

  data: () => ({
    filter: '',
    tableHeaders: [
      { text: 'id', value: 'id', sortable: false, align: 'start' },
      { text: 'Название', value: 'name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' },
    ],
    eventTypePartList: new EventTypePartList(),

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
  }),

  methods: {
    async getEventTypePartParent() {
      try {
        const data = await eventTypePartApi.getCatalog()
        if (data.length) data.forEach((obj) => this.eventTypePartList.add(obj))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения типов событий')
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },

    async saveEventTypePart(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await eventTypePartApi.update(body) : await eventTypePartApi.create(body)
        body.id ? this.eventTypePartList.update(data) : this.eventTypePartList.add(data)
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeEventTypePart() {
      try {
        this.removeLoading = true
        await eventTypePartApi.remove(this.selectedItem.id)
        this.eventTypePartList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },
  },
}
</script>
